module.exports = __webpack_public_path__ + "static/media/strop.9ce34b33.jpg";